import { Component, DestroyRef, OnInit } from '@angular/core';
import { ErrorService } from '../../../services/error.service';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { API, ReportingFullDTO } from '../../../services/api/api';
import { ReportingService } from '../../../services/reporting.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { mergeMap, takeWhile } from 'rxjs/operators';
import { interval } from 'rxjs';

@Component({
  selector: 'sb-comp-reporting-modal',
  templateUrl: './reporting-modal.component.html',
  styleUrls: ['./reporting-modal.component.scss'],
  standalone: false,
})
export class ReportingModalComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  report: ReportingFullDTO;
  waitForReport: boolean;

  constructor(
    private api: API,
    private errorHandler: ErrorService,
    private modalNavigation: ModalNavigationService,
    public reportingService: ReportingService,
    private destroyRef: DestroyRef
  ) {
    this.report = null;
    this.waitForReport = true;
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.report = this.modalNavigation.getCurrentNavigation().data;
      if (this.report) {
        interval(5000)
          .pipe(
            takeWhile(() => this.waitForReport),
            mergeMap(() => this.api.shared_Reporting_retrieveById(this.report?.id)),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe({
            next: (rep: ReportingFullDTO) => {
              this.report = rep;
              if (this.report?.renderingFinishedAt || this.report?.renderingFailedAt || this.report?.calculationFailedAt) {
                this.waitForReport = false;
              }
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
      }
    }
  }
}
